<script lang="ts">
  import TopBar from './shared/TopBar.svelte';
  import EditorNav from './shared/EditorNav.svelte';
  import ErrorBanner from './shared/ErrorBanner.svelte';
  import { editorStore } from '../../stores/editorStore';
</script>

<div class="editor-layout">
  <TopBar />
  <EditorNav />

  <main class="editor-main">
    <slot />
  </main>

  {#if $editorStore.error}
    <ErrorBanner message={$editorStore.error} />
  {/if}
</div>

<style>
  .editor-layout {
    min-height: 100vh;
    background: var(--color-bg-primary, #fff);
  }

  .editor-main {
    min-height: calc(100vh - 8rem);
    padding-bottom: 2rem;
  }
</style>
